module.exports = __webpack_public_path__ + "static/media/WB 2 Teacher 2.e5230ab4.svg";